import "./addCheque.scss";
import {useEffect, useState} from "react";
import { toast } from "react-toastify";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { FaToEnDigits } from "../../utils/faToEnDigits";
import { useFormFields } from "../../hooks/useFormFields";
import { AddCheque } from "../../services/chequeService";
import Button from "../button/button";
import DateChooser from "../dateChooser/dateChooser";
import TextInput from "../textInput/textInput";
import IconButton from "../iconButton/iconButton"
import BankSelectList from "../bankSelectList/bankSelectList";
import AddChequeIcon from "../../assets/images/chequePassive.svg";
import EnterIcon from "../../assets/images/enter.svg";
import CloseIcon from "../../assets/images/closeCancel.svg";

export default function AddChequeComponent({currentDate, afterAddCheque, onClose}) {
  const [loading, setLoading] = useState(false);
  let { fields, handleFields } = useFormFields({
      date: "",
      sayadNumber: "",
      bankName: "",
      chequeNumber: "",
      dueDate: "",
      amount: "",
      owner: "",
      ownerNationalCode: "",
      reason: "",
      reminderDate: "",
    });
  
  useEffect(() => {
    handleFields(FaToEnDigits(currentDate.format("YYYYMMDD")), "date");
  }, [currentDate]);

  const handleDates = (e) => {
    fields["dueDate"] = e;
    handleFields(new DateObject({
      date: e.valueOf(),
      calendar: persian,
      locale: persian_fa,
    }).subtract(1, "day"), "reminderDate");
  }

  const addCheque =  async (e) => {
    const payload = {...fields}
    var pureAmount = payload.amount.replace(/[٬,]/g, "");
    payload["amount"] = pureAmount.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    payload["amount"] = parseInt(payload.amount)
    if (Object.values(payload).every((value) => value !== "")) {
      if (payload.amount > 0) {
        try {
          payload["dueDate"] = FaToEnDigits(payload.dueDate.format("YYYYMMDD"));
          payload["reminderDate"] = FaToEnDigits(payload.reminderDate.format("YYYYMMDD"));
          setLoading(true);
          await AddCheque(payload);
          setLoading(false);
          afterAddCheque();
          } catch (err) {
            setLoading(false);
            toast.error(err.error, { toastId: "error" });
          }
      } else {
        toast.error("مبلغ چک صحیح نیست", { toastId: "error" });
      }
    } else {
       toast.error("وارد کردن تمامی موارد الزامی است", { toastId: "error" });
    }
  }

  return (
    <div className="addCheque form actionWrapper">
      <IconButton icon={CloseIcon} tooltip="بیخیال" onClick={onClose} className="closeIcon" />
      <img src={AddChequeIcon} alt="icon" className="notMobile"/>
      <div className="chequeRows">
        <div className="chequeRow">
          <BankSelectList onChange={(e) => handleFields(e, "bankName")} />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"شماره چک"}
            val={fields.chequeNumber}
            onChange={(e) => handleFields(e, "chequeNumber")}  
            direction={"ltr"}
          />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"شناسه صیادی"}
            val={fields.sayadNumber}
            onChange={(e) => handleFields(e, "sayadNumber")}  
            direction={"ltr"}
          />
        </div>
        <div className="chequeRow">
          <DateChooser label="تاریخ:" date={fields.dueDate} setDate={(e) => handleDates(e)} minDate={0} inputWidth="160px" />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"مبلغ"}
            val={fields.amount}
            onChange={(e) => handleFields(e, "amount")}  
            validation="amount"
            direction={"ltr"}
          />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"در وجه"}
            val={fields.owner}
            onChange={(e) => handleFields(e, "owner")}  
          />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"کد/شناسه ملی"}
            val={fields.ownerNationalCode}
            onChange={(e) => handleFields(e, "ownerNationalCode")}
            direction={"ltr"}
          />
        </div>
        <div className="chequeRow">
          <TextInput
            label={"بابت"}
            val={fields.reason}
            onChange={(e) => handleFields(e, "reason")}  
          />
        </div>
        <div className="chequeRow">
          <DateChooser label="تاریخ یادآوری:" date={fields.reminderDate} setDate={(e) => handleFields(e, "reminderDate")} minDate={0} maxDate={fields.dueDate} inputWidth="160px" />
        </div>
      </div>
      <Button text="ثبت"  onClick={() => addCheque()} className="center notDesktop" width={100} />
      <IconButton icon={EnterIcon} loading={loading} tooltip="ثبت" onClick={() => addCheque()}  className="notMobile"/>
    </div>
  );
}
